// extracted by mini-css-extract-plugin
module.exports = {"horizontalScroll":"styles_horizontalScroll__NYwr8","selected":"styles_selected__Jev9p","btnLeft":"styles_btnLeft__o9l0b","btnRight":"styles_btnRight__wkPmW"};